interface TeamColors {
  primary: string;
  secondary: string;
}

export const teamColors: Record<number, TeamColors> = {
  108: { primary: '#BA0021', secondary: '#ffffff' }, // LA Angels
  109: { primary: '#A71930', secondary: '#E3D4AD' }, // AZ Diamondbacks
  110: { primary: '#DF4601', secondary: '#000000' }, // Baltimore Orioles
  111: { primary: '#BD3039', secondary: '#0D2B56' }, // Boston Red Sox
  112: { primary: '#0E3386', secondary: '#CC3433' }, // Chicago Cubs
  113: { primary: '#C6011F', secondary: '#000000' }, // Cincinnati Reds
  114: { primary: '#E31937', secondary: '#0C2340' }, // Cleveland Guardians
  115: { primary: '#33006F', secondary: '#C4CED4' }, // Colorado Rockies
  116: { primary: '#0C2340', secondary: '#FA4616' }, // Detroit Tigers
  117: { primary: '#002D62', secondary: '#EB6E1F' }, // Houston Astros
  118: { primary: '#004687', secondary: '#C09A5B' }, // Kansas City Royals
  119: { primary: '#005A9C', secondary: '#EF3E42' }, // LA Dodgers
  120: { primary: '#AB0003', secondary: '#14225A' }, // Washington Nationals
  121: { primary: '#002D72', secondary: '#FF5910' }, // NY Mets
  133: { primary: '#003831', secondary: '#EFB21E' }, // Oakland Athletics
  134: { primary: '#27251F', secondary: '#FDB827' }, // Pittsburgh Pirates
  135: { primary: '#2F241D', secondary: '#FFC425' }, // San Diego Padres
  136: { primary: '#0C2C56', secondary: '#C4CED4' }, // Seattle Mariners
  137: { primary: '#FD5A1E', secondary: '#27251F' }, // SF Giants
  138: { primary: '#C41E3A', secondary: '#0C2340' }, // St. Louis Cardinals
  139: { primary: '#092C5C', secondary: '#8FBCE6' }, // Tampa Bay Rays
  140: { primary: '#003278', secondary: '#C0111F' }, // Texas Rangers
  141: { primary: '#134A8E', secondary: '#E8291C' }, // Toronto Blue Jays
  142: { primary: '#002B5C', secondary: '#D31145' }, // Minnesota Twins
  143: { primary: '#E81828', secondary: '#002D72' }, // Philadelphia Phillies
  144: { primary: '#CE1141', secondary: '#13274F' }, // Atlanta Braves
  145: { primary: '#27251F', secondary: '#C4CED4' }, // Chicago White Sox
  146: { primary: '#00A3E0', secondary: '#EF3340' }, // Miami Marlins
  147: { primary: '#003087', secondary: '#C4CED4' }, // NY Yankees
  158: { primary: '#12284B', secondary: '#FFC52F' }, // Milwaukee Brewers
};

const defaultTeamColors: TeamColors = { primary: '#555555', secondary: '#ffffff' };

export function getTeamColors(teamId: number): TeamColors {
  return teamColors[teamId] ?? defaultTeamColors;
}
